import { createSlice } from "@reduxjs/toolkit";

const initialNewAdspositionSlice = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],

  contestData: [],
  contestUsers: [],
  retentionreportlist: [],
  gameList: [],
  gameTypeList: [],
  company: [],
  upload: {},
  hostListList: [],
  PositionListList: [],
  // imageField : undefined,
  screenShots: [],
  totalJoinedPlayers: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const NewAdspositionSlice = createSlice({
  name: "newAdspositionSlice",
  initialState: initialNewAdspositionSlice,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    hostListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice", totalCount, entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    PositionListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice", totalCount, entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    contestDetails: (state, action) => {
      const { contestData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestData = contestData;
    },
    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },

    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
    },
    // imageUploaded: (state, action) => {
    //   const { entities, imageField} = action.payload;
    //   // console.log('in e',entities)
    //   // console.log('in f',imageField)

    //   state.error = null;
    //   state.upload = entities;
    //   state.imageField = imageField;
    // },
  },
});
